var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{attrs:{"id":"navigator-widget-ui"}}),_c('catalog-pull-out',{attrs:{"isPullOutLoading":false,"collectionData":_vm.collectionData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }